"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  api: {
    host: 'https://api-uat.iyunbao.com'
  },
  iybweb: {
    host: 'https://uat.iyunbao.com/iyb'
  },
  iybtm: {
    host: 'https://api-uat.iyb.tm'
  }
};
exports.default = _default;